import React from 'react';

import { OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const InputTooltip = props => {
    return (
      <OverlayTrigger placement="right" delay={{ show: 120, hide: 30 }} overlay={props.children}>
        <FontAwesomeIcon icon={faQuestionCircle} className="m-1" />
      </OverlayTrigger>
    );
};

export default InputTooltip;
